import { HttpParams } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { LazyLoadEvent } from 'primeng/primeng';

import { BaseCrudService } from '../../shared/_utils/services/base-crud-service';
import { QueryOperator } from '../../shared/_utils/services/query-operator.enum';
import { PoiHead } from '../entities/poi-head';

@Injectable()
export class PoiHeadService extends BaseCrudService<PoiHead> {

  public uri = '/api/poiHead/';

  constructor(injector: Injector) {
    super(injector);
   //console.log('Instance PoiHeadService');
  }

  buildSentence(entity?: PoiHead, event?: LazyLoadEvent): HttpParams {
    if (entity) {
      let query = '';
      query = query.concat(
        entity.code ?
          `code${QueryOperator.Contain}${entity.code}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        entity.planningObjectiveId ?
          `planningObjectiveId${QueryOperator.Contain}${entity.planningObjectiveId}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      if (entity.costCenter && entity.costCenter.id) {
        query = query.concat(
          `costCenter.id${QueryOperator.Equal}${entity.costCenter.id}${QueryOperator.Split}`
        );
      }
      if (entity.event && entity.event.id) {
        query = query.concat(
          `event.id${QueryOperator.Equal}${entity.event.id}${QueryOperator.Split}`
        );
      }
      this.httpParams = this.httpParams.set(QueryOperator.QueryParam, query);
    }

    if (event) {
      const page = ((event.first + event.rows) / event.rows - 1).toString();
      const size = event.rows.toString();
      this.httpParams = this.httpParams.set(QueryOperator.PageParam, page);
      this.httpParams = this.httpParams.set(QueryOperator.SizeParam, size);
    }
    return this.httpParams;
  }

}



// WEBPACK FOOTER //
// ./src/app/core/services/poi-head.service.ts